import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { getUacBaseUrl } from "@/utils/tools";

const baseURL = getUacBaseUrl();

const service = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: true
});
const serviceWithNoCredential = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: false
});
// axios.defaults.withCredentials = true
service.interceptors.request.use(
  config => {
    const token = getToken(); // undefine
    config.headers["lang"] = store.state.lang;
    if (config.params && config.params.headers && config.params.headers.lang) {
      config.headers["lang"] = config.params.headers.lang;
    }
    config.headers["token"] = token;

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.ret !== 0) {
      res.msg &&
        Message({
          message: res.msg,
          type: "error",
          duration: 6 * 1000
        });
      if (res.ret === 3007) {
        store.dispatch("reset");
        if (window.vm.$route.name != "login") {
          window.vm.$router.push({ path: "/login" });
        }
      }
      // return res.data;
      return Promise.reject(res.ret);
    } else {
      return res.data;
    }
  },
  error => {
    error.message &&
      Message({
        message: error.message,
        type: "error",
        duration: 6 * 1000
      });
    return Promise.reject(error);
  }
);

export const postKeyValueRequest = (url, params) => {
  return service({
    method: "post",
    url: `${url}`, //url就是你传进来的请求
    data: params,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      }
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
};
//post请求接口
export const postRequest = (url, params) => {
  return service({
    method: "post",
    url: `${url}`,
    data: params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
//文件上传接口
export const uploadFileRequest = (url, params) => {
  return service({
    method: "post",
    url: `${url}`,
    data: params,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
//put请求接口
export const putRequest = (url, params) => {
  return service({
    method: "put",
    url: `${url}`,
    data: params,
    headers: {
      "Content-Type": "application/json"
    }
  });
};
//delete请求接口
export const deleteRequest = url => {
  return service({
    method: "delete",
    url: `${url}`
  });
};
//get请求接口
export const getRequest = (url, params) => {
  return service({
    method: "get",
    url: `${url}`,
    params
  });
};
export const getRequestWithNoCredential = (url, params) => {
  return serviceWithNoCredential({
    method: "get",
    url: `${url}`,
    params
  });
};
